//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  TextField,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';
import { DataTypeSelect    } from '../DataTypeSelect/DataTypeSelect';

// === UTILS ===

//#endregion

//-----------------------------------------------------------------
export function ConstantControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data, is_predicate } = props;

  const { updateExpression, updatePredicate } = useContext( ExpressionContext );
  
  const [ text, setText ] = useState( data?.value );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn: 3,
      gridRow: 1,
      // -----
      display: 'grid',
      width:'100%',
      columnGap:'0.5rem',
      gridTemplateColumns:'auto 1fr',
      gridTemplateRows:'1fr'
    },
    text_value: {
      maxWidth: '40rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const TEXT_VALUE = {
    sx    : _styles.text_value,
    value : text,
    size  : 'small',
    onBlur    : onBlur    ,
    onChange  : onChange  ,
    onKeyDown : onKeyDown ,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    setText( event.target.value );
    // updateExpression( props.id , { value: event.target.value } )
  }
  
  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter') {
      const update = is_predicate ? updatePredicate : updateExpression;
      update( id , { value: event.target.value } );
    }
  }
  
  //-----------------------------------------------------------------
  function onBlur( event ) {
    //-----------------------------------------------------------------
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { value: text } );
  }


  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container} >
        <DataTypeSelect id={id} type={data?.type} />
        <TextField { ...TEXT_VALUE } />
      </div>
    );
  }

  //#endregion

  return display();
}
